"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DetailsPopupComponent = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseDialogs = require("nicbase-dialogs");

var _nicbaseForms = require("nicbase-forms");

var _nicbaseTranslation = require("nicbase-translation");

var _detailsComponent = _interopRequireDefault(require("./details-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable no-param-reassign */
var DetailsPopupComponent = function DetailsPopupComponent(_ref) {
  var intl = _ref.intl,
      onCancel = _ref.onCancel,
      tour = _ref.tour,
      isActive = _ref.isActive;
  var dialogTitle = 'widgets.tourBoard.details';
  var actions = [/*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiButton, {
    key: "2",
    primary: true,
    raised: true,
    className: "action-button cancel-button",
    onClick: onCancel
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "common.ok",
    tagName: "span"
  }))];
  return /*#__PURE__*/_react["default"].createElement(_nicbaseDialogs.BasisDialog, {
    active: isActive,
    title: intl.formatMessage({
      id: dialogTitle
    }),
    content: /*#__PURE__*/_react["default"].createElement(_detailsComponent["default"], {
      tour: tour
    }),
    actions: actions,
    onRequestCancel: onCancel,
    onRequestClose: onCancel
  });
};

exports.DetailsPopupComponent = DetailsPopupComponent;

var noop = function noop() {};

DetailsPopupComponent.propTypes = {
  isActive: _propTypes["default"].bool.isRequired,
  onCancel: _propTypes["default"].func,
  tour: _propTypes["default"].shape({}),
  intl: _nicbaseTranslation.intlShape.isRequired
};
DetailsPopupComponent.defaultProps = {
  tour: {
    alarms: [],
    route: null
  },
  onCancel: noop
};

var _default = (0, _nicbaseTranslation.injectIntl)(DetailsPopupComponent);

exports["default"] = _default;